<template>
  <div class="xtgg">
    <div style="font-size: 15px; font-weight: bold; text-align: center; color: white">
      系统公告
    </div>
    <div class="xtgg_desc">
      <div style="font-size: 15px; font-weight: bold; text-align: center; color: #0850fc">
        同步单通知
      </div>
      <!-- <div style="text-align: center">
        <canvas ref="qrcodeCanvas"></canvas>
      </div> -->
      <span style="font-size: 13px">
        1.注册:手机号验证，可用于手机号修改 或发货人验证<br />
        2.礼品网：不选择中转仓订单<br />
        3.订单查询，增加店铺分组<br />
        4.用户韵达同步上家单号绑定失败或其他异常，及时提示。韵达延迟15分钟后绑定失败自动退款并通知：订单编号：123456789，生成韵达单号321456987，因地址无法到达关联失败，请使用其他单号发送。已自动退款
      </span>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      kfwx_ewm: "",
    };
  },
  async created() {
    await this.$root.getSystemInfo();
    this.kfwx_ewm = Cookies.get("view_qrcode_url");
    this.generateQRCode("ffrwaer3221");
  },
  methods: {
    generateQRCode(url) {
      const options = {
        width: 70, // 控制二维码的宽度（像素）
        // height: 100 // 可以同时设置高度，如果你希望二维码是一个正方形，只需要设置宽度即可
        margin: 1,
        color: {
          dark: "#505050", // 灰色
          light: "#ffffff", // 白色（背景）
        },
      };
      QRCode.toCanvas(this.$refs.qrcodeCanvas, url, options, (error) => {
        if (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>

<style scoped>
.xtgg {
  background-color: #0850fc;
  width: 10vw;
  border-radius: 1.3em;
  /* height: 56vh; */
  margin-left: 15px;
  margin-top: 1.5vh;
  text-align: left;
  padding: 6px;
  border: #525252 1px solid;
}
.xtgg_desc {
  background-color: white;
  border-radius: 1em;
  margin-top: 5px;
  margin-left: 2px;
  margin-right: 2px;
  /* height: 51vh; */
  padding: 10px;
  font-weight: bold;
  color: rgb(110, 110, 110);
}
</style>



// WEBPACK FOOTER //
// src/views/xtgg/index.vue